import { FunctionComponent, ReactElement } from 'react';
import { SiteSelectProps, SiteSelectType } from './types';
import SiteMultiSelect from './SiteMultiSelect';
import SiteSingleSelect from './SiteSingleSelect';

const SiteSelectField: FunctionComponent<SiteSelectProps> = ({ type, ...rest }): ReactElement => {
	if (type === SiteSelectType.MULTISELECT) {
		return <SiteMultiSelect {...rest} />;
	}

	return <SiteSingleSelect {...rest} />;
};

export default SiteSelectField;
